module.exports = __webpack_public_path__ + "img/calin.1ff64f80.png";